<template lang="pug">
	.section-actions-remove(v-if="showed && Template.SelectedTemplate")
		.card
			.card-header
				i.fa.fa-edit
				span Remove Section
			.card-body.collapse.show
				.form-horizontal
					.mx-auto.form-group
						label.mx-auto.col-form-label Are you sure you want to remove this section?

					.form-actions
						button.btn.btn-danger(type="submit" v-on:click="remove()") Remove section
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import _ 					from 'lodash';

	import Screen 				from './../../mixins/screen';

	import { Template } 		from './../../services/Template';
	import { Section } 			from "../../services/Section";
	import { Metadata }			from "../../services/Metadata";
	import { Project }			from "../../services/Project"

	export default {
		name: "SectionActionsRemove",
		mixins: [Screen],
		screen: {
			events: {
				"Section Selected": function(sectionId) {
					this.sectionId = sectionId;
				}
			},
			updateOn: [],
			showed: false
		},
		data() {

			this.Template = Template;

			return {};

		},
		methods: {
			collectData() {

			},
			remove() {


				Server.sendToSocket({
					RemoveSection: {
						section_id: this.sectionId,
						project_id: Project.SelectedProject.id
					}
				});

				this.hide();

			},


		}
	}
</script>


<style lang="sass">

	.section-actions-remove
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 180px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark
				float: right
				color: #fff

</style>

